module.exports = __webpack_public_path__ + "img/live.d33545fb.jpg";